import cn from "classnames";
import { Media } from "components";
import { useMemo } from "react";

import { FeedInsertType, FeedInsertWidth } from "../../../constants";
import { NameAndPreviewCellProps } from "../FeedInsertsTable.types";

import styles from "../FeedInsertsTable.module.scss";

const NameAndPreviewCell = ({ feedInsert }: NameAndPreviewCellProps) => {
  const mediasToShow = useMemo(() => {
    switch (feedInsert.type) {
      case FeedInsertType.SingleMedia:
        return [feedInsert.media[0].media];
      case FeedInsertType.MultipleMedia:
        return feedInsert.media.slice(0, 3).map((media) => media.media);
      case FeedInsertType.Products:
        return [
          ...(feedInsert.metadata?.productSet?.productVariants.map(
            (product) => product.productVariant.image
          ) ?? []),
          ...(feedInsert.metadata?.productVariants?.map(
            (product) => product.image
          ) ?? [])
        ]
          .filter(Boolean)
          .slice(0, 3);
      default:
        return [];
    }
  }, [feedInsert.media]);

  const Preview = useMemo(() => {
    return mediasToShow.map((media, index) => {
      const isMediaVertical = Number(media?.width) < Number(media?.height);

      return (
        <Media
          key={media.id}
          className={cn(styles.feedInsertPreview_media, {
            [styles.feedInsertPreview_media__mediaVertical]:
              feedInsert.form === FeedInsertWidth.ProductSize ||
              (feedInsert.type === FeedInsertType.MultipleMedia &&
                Number(media?.width) < Number(media?.height)),
            [styles.feedInsertPreview_media__mediaHorizontal]:
              (feedInsert.form === FeedInsertWidth.FullWidth &&
                feedInsert.type === FeedInsertType.SingleMedia) ||
              (feedInsert.type === FeedInsertType.MultipleMedia &&
                Number(media?.width) >= Number(media?.height)),
            [styles.feedInsertPreview_media__singleMediaFullWidthThin]:
              feedInsert.form === FeedInsertWidth.FullWidthThin,
            [styles.feedInsertPreview_media__mediaProduct]:
              feedInsert.type === FeedInsertType.Products
          })}
          style={{
            zIndex: index + 1,
            marginLeft:
              index === 0
                ? 0
                : isMediaVertical || feedInsert.type === FeedInsertType.Products
                  ? -6
                  : -25
          }}
          mediaFile={media}
          withVideoLabel
        />
      );
    });
  }, [mediasToShow]);

  return (
    <div className={styles.feedInsertsTable_nameCell}>
      <div className={styles.feedInsertPreview}>{Preview}</div>
      {feedInsert.name}
    </div>
  );
};

export default NameAndPreviewCell;
